export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left Content */}
          <div className="flex-1 order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 bg-cyan-50 border border-cyan-200 rounded-full px-4 py-1.5 mb-6">
              <span className="text-cyan-600 text-xs font-semibold tracking-widest uppercase">About Us</span>
            </div>

            <h2
              className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight mb-6"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Expert Team Building
              <br />
              <span className="text-cyan-500">Modern iOS Solutions</span>
            </h2>

            <div className="space-y-4 text-slate-600 text-base md:text-lg leading-relaxed mb-8">
              <p>
                <strong>VITEK D.O.O.</strong> is a dedicated software development company headquartered in Skopje, North Macedonia. We specialize exclusively in the iOS ecosystem, crafting applications that combine elegant design with robust engineering.
              </p>
              <p>
                Our team brings together seasoned iOS engineers, UX designers, and security specialists who share a single mission: to deliver applications that genuinely improve people's digital lives. Every product we ship is the result of rigorous testing, thoughtful design, and a deep understanding of what mobile users need.
              </p>
              <p>
                From enterprise-grade VPN infrastructure to intelligent device optimization tools, we build software that users trust — and keep coming back to.
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: 'ri-shield-line', title: 'Security First', desc: 'Every product is built with privacy and security as core principles.' },
                { icon: 'ri-code-s-slash-line', title: 'Clean Engineering', desc: 'Maintainable, performant code that scales with user needs.' },
                { icon: 'ri-user-heart-line', title: 'User-Centric', desc: 'Intuitive interfaces designed for real people, not just developers.' },
                { icon: 'ri-award-line', title: 'Quality Driven', desc: 'Rigorous QA processes ensure every release meets our high standards.' },
              ].map((v) => (
                <div key={v.title} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-slate-100">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-cyan-50 shrink-0">
                    <i className={`${v.icon} text-cyan-600 text-base`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-slate-800 mb-0.5">{v.title}</p>
                    <p className="text-xs text-slate-500 leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Visuals */}
          <div className="flex-1 order-1 lg:order-2 relative flex justify-center">
            <div className="relative w-full max-w-md">
              {/* Main image */}
              <div className="w-full h-72 md:h-96 rounded-3xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/1c7e1ec450c1668d86a8fb4499ad7f3c.jpg"
                  alt="VITEK D.O.O. development team"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Floating card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 border border-slate-100 flex items-center gap-3 shadow-sm">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-teal-50">
                  <i className="ri-apple-line text-teal-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-slate-500">Platform</p>
                  <p className="text-sm font-bold text-slate-900">iOS Specialists</p>
                </div>
              </div>

              {/* Stats card */}
              <div className="absolute -top-6 -right-6 bg-slate-900 rounded-2xl p-4 text-white">
                <p className="text-3xl font-bold text-cyan-400" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>100K+</p>
                <p className="text-xs text-slate-400 mt-0.5">Active Users</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
